import { createSlice } from '@reduxjs/toolkit';

const eventInfoSlice = createSlice({
  name: 'eventInfo',
  initialState: {
    eventInfo: null,
  },
  reducers: {
    setEventInfo: (state, action) => {
      state.eventInfo = action.payload;
    },
    clearEventInfo: (state) => {
      state.eventInfo = null;
    },
  },
});

export const { setEventInfo, clearEventInfo } = eventInfoSlice.actions;

export default eventInfoSlice.reducer;
